import React from "react";

import Lamina23img from "../images/lamina23img.png";
import Lamina23texto from "../images/lamina23texto.png";
import Lamina23actividad from "../images/lamina23actividad.png";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import TitleSmall from "../components/TitleSmall";
import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  green: {
    color: theme.palette.green.main,
    borderColor: theme.palette.green.main,
  },
  root: {
    textAlign: "center",
    "& p": {
      textAlign: "left",
    },
    "& li": {
      textAlign: "left",
    },
    "& h1": {
      textAlign: "left",
    },
    [theme.breakpoints.down("md")]: {
      "& img": {
        maxWidth: "100% !important",
      },
    },
  },
}));

const Lamina23 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 23: La importancia de cuidar nuestras lenguas"
        meta={[
          {
            property: "og:title",
            content: "Lámina 23: La importancia de cuidar nuestras lenguas",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "Una de las principales riquezas del Perú está en la diversidad de lenguas que hablamos. ",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="23" color="green" />

      <Container maxWidth="md" className={classes.contentLamina}>
        <Title
          title="La importancia de cuidar nuestras lenguas"
          color="green"
          size="md"
        />
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <p>
              Una de las principales riquezas del Perú está en la diversidad de
              lenguas que hablamos. Esta variedad enriquece nuestra cultura,
              pues las lenguas expresan la realidad en la que viven sus
              hablantes, lo que nos permite conocer, aprender y comprender
              formas distintas de entender el mundo.
            </p>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <img src={Lamina23texto} alt="Nuestras lenguas" />
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="green" />
        <p>
          <strong>Lee las siguientes palabras con sus significados.</strong>{" "}
          Luego, únelas con una línea a las imágenes que mejor las representen.
        </p>
        <img src={Lamina23actividad} alt="Actividad" />
        <p>
          ¿Habías usado antes estas palabras? Escribe una oración en la que uses
          alguna de estas palabras.
        </p>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <TitleSmall title="CONSERVEMOS NUESTRA RIQUEZA" color="green" />
        <p>
          Las lenguas se mantienen vivas cuando las personas las utilizamos en
          nuestra comunicación, pero no todas sobreviven. A lo largo de la
          historia del Perú, se han extinguido muchas lenguas debido a diversas
          circunstancias. A veces las personas prefieren adoptar las lenguas más
          extendidas, como el quechua o el castellano. Otras veces sucede porque
          desaparecen las poblaciones que las hablan. En la actualidad, se
          plantea que es muy importante preservar las lenguas originarias y
          evitar que desaparezcan.
        </p>
        <p>
          <strong>Responde:</strong> ¿Por qué crees que es importante preservar
          nuestras lenguas originarias? ¿Cómo podemos contribuir a su
          valoración, respeto y preservación?
        </p>
        <Actividad color="green" />
        <p>
          <strong>
            Observa las siguientes imágenes y responde la pregunta.
          </strong>{" "}
        </p>
        <img src={Lamina23img} alt="Actividad" />
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/07/Ciudadanía-Activa-Lámina-23.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          classes={{ root: classes.green }}
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 23: La importancia de cuidar nuestras lenguas'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={TextTrackCueList}
        anterior="Las lenguas del Perú"
        anteriorEnlace="/lamina-1-22"
        siguiente="La democracia y las elecciones"
        siguienteEnlace="/lamina-1-24"
      />
    </>
  );
};

export default Lamina23;
